/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.CostCenterListResponseDto>
>;
export function request(
  params: API.basics.costCenter.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costCenter/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
